import * as index from '@syncfusion/ej2-treegrid';
index.TreeGrid.Inject( index.Filter,index.Page,index.Sort,index.Reorder,index.Toolbar,index.Aggregate,index.Resize,index.ColumnMenu,index.ExcelExport,index.PdfExport,index.CommandColumn,index.ContextMenu,index.Edit,index.Selection,index.VirtualScroll,index.DetailRow,index.RowDD);
export * from '@syncfusion/ej2-treegrid';
